import React, { Component } from 'react';
import FormPushNotification from './Form/FormPushNotification';
import { addPushNotification, sendPushNotificationEvent } from '../../data/PushNotifications/actions';

class PushNotificationAdd extends Component {
    render() {
        return <FormPushNotification type="add" sendDataFunc={addPushNotification} sendEventFunc={sendPushNotificationEvent} />;
    }
}

export default PushNotificationAdd;



// WEBPACK FOOTER //
// ./environments/fhe/scenes/PushNotification/add.js